import { encryptLeads } from "@repo/shared-utils/crypto";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import type { IndicesInsightsConfig, ScripInfoData } from "./Interface";

type IndicesActionType = "optionChain" | "chart";

const handleIndicesActionClick = async (
  actionType: IndicesActionType,
  currentData: ScripInfoData | null,
  config?: IndicesInsightsConfig,
) => {
  if (!currentData) return;

  try {
    const { mobileNo } = await getSessionData();
    if (!mobileNo) {
      console.error("Mobile number not found");
      return;
    }

    const actionsConfig = config?.actions;
    const screen =
      actionType === "optionChain"
        ? actionsConfig?.optionChainScreen ?? "scripdetails"
        : actionsConfig?.chartsScreen ?? "chartScreen";

    const title =
      actionType === "optionChain"
        ? actionsConfig?.optionChainWebViewTitle ?? "Option Chain"
        : actionsConfig?.chartsWebViewTitle ?? "Chart";

    const basePayload = {
      screen,
      token: String(currentData.token),
      symbol: currentData.compName,
      mobileNo,
      isIndiceSym: true,
    };

    const payload =
      actionType === "optionChain"
        ? { ...basePayload, isOptionsChain: true }
        : basePayload;

    const encryptedPayload = await encryptLeads(JSON.stringify(payload));
    const url = new URL(
      actionsConfig?.tradingMallBaseUrl ??
        "https://bfsltrade.bajajfinservsecurities.in/tradingmall",
    );
    url.searchParams.append("req", encryptedPayload);

    if (isOpenInApp()) {
      const windowWithTarsier = globalThis as unknown as Window & {
        tarsier?: {
          invokePrompt: (prompt: string, force?: boolean) => unknown;
        };
      };
      windowWithTarsier.tarsier?.invokePrompt(
        `openInAppWebViewActivity://${JSON.stringify({
          url: url.toString(),
          title,
        })}`,
        true,
      );
    } else {
      (globalThis as unknown as Window).open(url.toString(), "_blank");
    }
  } catch (error) {
    console.error("Error handling indices action click:", error);
  }
};

export const handleOptionChainClick = async (
  currentData: ScripInfoData | null,
  config?: IndicesInsightsConfig,
) => handleIndicesActionClick("optionChain", currentData, config);

export const handleChartClick = async (
  currentData: ScripInfoData | null,
  config?: IndicesInsightsConfig,
) => handleIndicesActionClick("chart", currentData, config);
